(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection__main"]) return;
  try {
    
  if (Shopify.designMode) {
    // Close overlay-drawer when any section is selected in theme editor
    document.addEventListener('shopify:section:select', function() {
      const overlayDrawer = document.querySelector('overlay-drawer');
      if (overlayDrawer) overlayDrawer.close();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["esl-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('esl-video-hero')) {
    customElements.define('esl-video-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.video = this.querySelector('video');
        this.button = this.querySelector('.esl-vhero__toggle');
        if (!this.video || !this.button) return;
        this.controller = new AbortController();
        this.options = { signal: this.controller.signal };
        this.mobile = matchMedia('(max-width: 767px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.pageLoaded = document.readyState === 'complete';
        this.visible = false;
        this.userPaused = false;
        this.failed = false;
        this.selectedSource = null;
        this.pending = null;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.sync = this.sync.bind(this);
        this.mobile.addEventListener('change', this.sync, this.options);
        this.reducedMotion.addEventListener('change', this.sync, this.options);
        this.connection?.addEventListener('change', this.sync, this.options);
        document.addEventListener('visibilitychange', this.sync, this.options);
        window.addEventListener('load', () => {
          this.pageLoaded = true;
          this.sync();
        }, this.options);
        this.video.addEventListener('playing', () => {
          if (!this.allowed() || !this.visible || document.hidden || this.userPaused) {
            this.video.pause();
            return;
          }
          this.setAttribute('data-has-frame', '');
          this.updateButton();
        }, this.options);
        this.video.addEventListener('pause', () => this.updateButton(), this.options);
        this.video.addEventListener('error', () => {
          this.failed = true;
          this.removeAttribute('data-has-frame');
          this.sync();
        }, this.options);
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          if (this.userPaused) {
            this.cancelPending();
            this.video.pause();
          } else {
            this.failed = false;
            this.start();
          }
          this.updateButton();
        }, this.options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.sync();
          }, { threshold: 0 });
          this.observer.observe(this);
        } else {
          const updateVisibility = () => {
            const rect = this.getBoundingClientRect();
            this.visible = rect.bottom > 0 && rect.top < window.innerHeight;
            this.sync();
          };
          window.addEventListener('scroll', updateVisibility, { passive: true, signal: this.controller.signal });
          window.addEventListener('resize', updateVisibility, this.options);
          updateVisibility();
        }
        this.sync();
      }
      sources() {
        const parse = value => {
          try {
            const sources = JSON.parse(value || '[]');
            return Array.isArray(sources) ? sources : [];
          } catch { return []; }
        };
        const mobileSources = parse(this.dataset.mobileSources);
        const desktopSources = parse(this.dataset.desktopSources);
        const sources = this.mobile.matches && mobileSources.length ? mobileSources : desktopSources;
        return sources.filter(source => source.format === 'mp4' && source.url).sort((a, b) => a.width - b.width);
      }
      allowed() {
        if (this.reducedMotion.matches || this.connection?.saveData) return false;
        if (['slow-2g', '2g'].includes(this.connection?.effectiveType)) return false;
        return !this.mobile.matches || this.dataset.mobileEnabled === 'true';
      }
      updateButton() {
        const playing = !this.video.paused;
        this.toggleAttribute('data-playing', playing);
        this.button.querySelector('.esl-vhero__toggle-label').textContent = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
      }
      cancelPending() {
        if (!this.pending) return;
        if (this.pending.idle) window.cancelIdleCallback(this.pending.id);
        else clearTimeout(this.pending.id);
        this.pending = null;
      }
      sync() {
        const allowed = this.allowed();
        this.button.hidden = !allowed || this.failed || !this.pageLoaded || (!this.selectedSource && !this.sources().length);
        if (!allowed || this.failed) {
          this.cancelPending();
          this.video.pause();
          if (this.video.hasAttribute('src')) {
            this.video.removeAttribute('src');
            this.video.load();
          }
          this.removeAttribute('data-has-frame');
        } else if (!this.visible || document.hidden || this.userPaused) {
          this.cancelPending();
          this.video.pause();
        } else if (this.pageLoaded && !this.pending) {
          const callback = () => {
            this.pending = null;
            this.start();
          };
          this.pending = 'requestIdleCallback' in window
            ? { id: requestIdleCallback(callback, { timeout: 1500 }), idle: true }
            : { id: setTimeout(callback, 200), idle: false };
        }
        this.updateButton();
      }
      start() {
        if (!this.isConnected || !this.pageLoaded || !this.visible || document.hidden || this.userPaused || !this.allowed() || this.failed) return;
        if (!this.selectedSource) {
          const sources = this.sources();
          const cap = this.mobile.matches ? 960 : 1920;
          const suitable = sources.filter(source => source.width <= cap);
          const candidates = suitable.length ? suitable : sources.slice(0, 1);
          const width = Math.min(this.clientWidth, cap);
          this.selectedSource = candidates.find(source => source.width >= width) || candidates[candidates.length - 1];
        }
        if (!this.selectedSource) return;
        if (!this.video.hasAttribute('src')) this.video.src = this.selectedSource.url;
        const playback = this.video.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch(error => {
            if (error.name === 'AbortError') return;
            this.userPaused = true;
            this.removeAttribute('data-has-frame');
            this.updateButton();
          });
        }
      }
      disconnectedCallback() {
        this.cancelPending();
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
        this.removeAttribute('data-has-frame');
        this.removeAttribute('data-playing');
        if (this.video) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.load();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-announcement-slider"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class AnnouncementSliderSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;
    this.resizeTimeout = null;
    this.showArrows = this.data.show_arrows;
    this.observers = []; 
    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    this.$root.classList.remove('pxu-announcement-slider--initialized');

    const options = {
      prevNextButtons: true,
      pageDots: false,
      groupCells: false,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: this.data.auto_rotate ? this.data.rotation_speed * 1000 : false,
    };

    this.carousel = new Carousel(this.$root, options);
    this.carousel.onMount();

    setTimeout(() => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
      this.$root.classList.add('pxu-announcement-slider--initialized'); 
    }, 0);
  
    this.initEventListeners();
  }

  waitForElement(selector, callback) {
    const element = this.$root.querySelector(selector);
    
    if (element) {
      callback(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = this.$root.querySelector(selector);
      if (element) {
        obs.disconnect();
        callback(element);
        this.observers = this.observers.filter(o => o !== obs); 
      }
    });

    observer.observe(this.$root, { childList: true, subtree: true });
    this.observers.push(observer); 
  }

  initEventListeners() {
    this.events.register(window, 'resize', () => {
      this.toggleButtonVisibility(false);
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        this.adjustNavigationButtons();
        this.toggleButtonVisibility(this.showArrows);
      }, 200);
    });

    this.events.register(window, 'load', () => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
    });

    this.events.register(document, 'keydown', (event) => {
      if (event.key === 'Tab') {
        this.toggleButtonVisibility(true);
      }
    });

    this.events.register(document, 'click', (event) => {
      if (this.showArrows === false && !event.target.closest('.flickity-prev-next-button')) {
        this.toggleButtonVisibility(false);
      }
    });

    this.toggleButtonVisibility(false);
  }

  toggleButtonVisibility(visible) {
    this.waitForElement('.flickity-prev-next-button', () => {
      const buttons = this.$root.querySelectorAll('.flickity-prev-next-button');
      buttons.forEach(button => {
        button.style.transition = visible ? 'opacity 0.2s ease-out' : 'none';
        button.style.opacity = visible ? '1' : '0';
        button.style.pointerEvents = visible ? 'auto' : 'none';
      });
    });
  }

  adjustNavigationButtons() {
    this.waitForElement('.flickity-prev-next-button', () => {
      const prevButton = this.$root.querySelector('.flickity-prev-next-button.previous');
      const nextButton = this.$root.querySelector('.flickity-prev-next-button.next');
      const announcements = this.$root.querySelectorAll('.pxu-announcement-slider__text');
      const viewport = window.innerWidth;
      const container = this.$root.querySelector('.pxu-section__container');

      if (!announcements.length || !container) return;

      let maxWidth = 0;
      announcements.forEach((el) => {
        const width = el.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
      });

      const containerRect = container.getBoundingClientRect();
      const minWidth = 650;
      let buttonOffset = 8;

      if (viewport >= 860) {
        const containerLeftEdge = containerRect.left;
        const containerRightEdge = viewport - containerRect.right;
        const announcementMaxWidth = maxWidth;
        const announcementLeftEdge = containerLeftEdge + (containerRect.width - announcementMaxWidth) / 2;
        const announcementRightEdge = containerRightEdge + (containerRect.width - announcementMaxWidth) / 2;

        if (maxWidth <= minWidth) {
          const leftGap = (announcementLeftEdge - containerLeftEdge) / 2;
          const rightGap = (containerRightEdge - announcementRightEdge) / 2;
          const maxOffset = Math.min(leftGap, rightGap);
          buttonOffset = maxOffset;
        }
      }

      prevButton.style.left = `${-buttonOffset}px`;
      nextButton.style.right = `${-buttonOffset}px`;
    });
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
    this.events.unregisterAll();
    this.observers.forEach(observer => observer.disconnect());
    this.observers = [];
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-announcement-slider]').forEach(($section) => {
  Section.init($section, AnnouncementSliderSection);
});

if (Shopify.designMode) {
  window.PxuThemeSections.AnnouncementSliderSection = AnnouncementSliderSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-text"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class ScrollingTextSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.contentItems = this.$root.querySelectorAll('[data-scrolling-text-content]');

    this.onMount();
  }

  // Section lifecycle

  onMount() {
    this._initScroll();
  }

  _initScroll() {
    this.contentItems.forEach(el => {
      const textItems = el.querySelectorAll('[data-scrolling-text-content-item]');
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items.
      const totalItemWidth = [...textItems].reduce((total, item) => total + item.offsetWidth, 0);

      // Calculate the number of marquee items needed to fill the container.
      const numItems = Math.ceil(width / totalItemWidth);

      // Clone and append marquee items.
      for (let i = 0; i < numItems; i++) {
        textItems.forEach(item => {
          const clone = item.cloneNode(true);
          el.appendChild(clone);
        });
      }
    });

    this._observeAnimations();
  }

  _observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(debounce(([entry]) => {
      const { isIntersecting } = entry;
      this.$root.classList.toggle('pxu-scrolling-text--is-animated', isIntersecting);
    }, 100));

    this.observer.observe(this.$root);
  }

  onUnmount(){
    this.observer.unobserve(this.$root);
  }
}

document.querySelectorAll('[data-pxu-scrolling-text]').forEach(($section) => {
  Section.init($section, ScrollingTextSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ScrollingTextSection = ScrollingTextSection;
}

  } catch(e) { console.error(e); }
})();
})();
